export default function selfassigned(state = false, action){
  if (action.type === 'selfassigned') {
    return state = true;
  } else if (action.type === 'notselfassigned') {
    return state = false;
  } else {
    return state;
  }
}
